"use strict";

var _classCallCheck = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var R = __importStar(require("ramda"));

var utils_1 = require("@8base/utils");

var qs_1 = __importDefault(require("qs"));

var jwt_decode_1 = __importDefault(require("jwt-decode"));

var isEmptyOrNil = R.either(R.isNil, R.isEmpty);
/**
 * Creates instance of the web Cognito auth client.
 */

var WebCognitoAuthClient =
/*#__PURE__*/
function () {
  function WebCognitoAuthClient(options) {
    var storageOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, WebCognitoAuthClient);

    utils_1.throwIfMissingRequiredParameters(['domain', 'clientId', 'redirectUri'], utils_1.PACKAGES.WEB_COGNITO_AUTH_CLIENT, options);
    var logoutRedirectUri = options.logoutRedirectUri,
        clientId = options.clientId,
        redirectUri = options.redirectUri,
        domain = options.domain;
    this.storageAPI = new utils_1.StorageAPI(storageOptions.storage || window.localStorage, storageOptions.storageKey || 'auth', storageOptions.initialState);
    this.logoutHasCalled = false;
    this.clientId = clientId;
    this.redirectUri = redirectUri;
    this.logoutRedirectUri = logoutRedirectUri;
    this.domain = domain;
  }

  _createClass(WebCognitoAuthClient, [{
    key: "setState",
    value: function setState(state) {
      this.storageAPI.setState(state);
    }
  }, {
    key: "getState",
    value: function getState() {
      return this.storageAPI.getState();
    }
  }, {
    key: "purgeState",
    value: function purgeState() {
      this.storageAPI.purgeState();
    }
  }, {
    key: "checkIsAuthorized",
    value: function checkIsAuthorized() {
      var _this$getState = this.getState(),
          token = _this$getState.token;

      return R.not(isEmptyOrNil(token));
    }
  }, {
    key: "authorize",
    value: function authorize() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var link = "".concat(this.domain, "/oauth2/authorize?").concat(qs_1.default.stringify({
        client_id: this.clientId,
        response_type: 'token',
        redirect_uri: this.redirectUri
      }, {
        encode: false
      }));
      window.location.replace(link);
    }
  }, {
    key: "checkSession",
    value: function checkSession() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return null;
    }
  }, {
    key: "getAuthorizedData",
    value: function getAuthorizedData() {
      var querySearch = window.location.href.split('#')[1];
      var result = qs_1.default.parse(querySearch);
      var jwtResult = jwt_decode_1.default(result.id_token);
      return {
        idToken: result.id_token,
        accessToken: result.access_token,
        state: result.state,
        firstName: jwtResult.name,
        lastName: jwtResult.family_name,
        email: jwtResult.email
      };
    }
  }, {
    key: "getTokenInfo",
    value: function getTokenInfo() {
      var _this$getState2 = this.getState(),
          token = _this$getState2.token;

      if (!token) {
        return undefined;
      }

      return jwt_decode_1.default(token) || undefined;
    }
  }, {
    key: "logout",
    value: function logout() {
      var _this = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      window.addEventListener('unload', function () {
        _this.purgeState();
      });
      window.location.replace("".concat(this.domain, "/logout?").concat(qs_1.default.stringify({
        client_id: this.clientId,
        response_type: 'token',
        redirect_uri: this.redirectUri
      }, {
        encode: false
      })));
    }
  }]);

  return WebCognitoAuthClient;
}();

exports.WebCognitoAuthClient = WebCognitoAuthClient;